import type { EventTrackingDecorator } from '@change-corgi/core/eventTracker';

class DarkModeDecorator implements EventTrackingDecorator {
	// eslint-disable-next-line @typescript-eslint/naming-convention
	private readonly prefers_dark_mode: boolean;

	constructor() {
		this.prefers_dark_mode = prefersDarkMode();
	}

	async getEventTrackingData(): Promise<Readonly<Record<string, unknown>>> {
		return Promise.resolve({
			prefers_dark_mode: this.prefers_dark_mode,
		});
	}
}

function prefersDarkMode(): boolean {
	if (typeof window === 'undefined') return false; // SSR safety

	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (!window.matchMedia) return false;

	return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function createDarkModeDecorator(): DarkModeDecorator {
	return new DarkModeDecorator();
}
